/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpLogger from '@module-logger/mbp';
// import axios from 'axios';
import restClient from '../../../app/helpers/restClient';
import { getGuestUserAccessToken } from '../../../state/ducks/Member/ducks/Auth/Plugin/auth/guest';

export const emailTranscript = async (jwt, payload, isCSPEnabled) => {
    try {
        const freshToken = await getGuestUserAccessToken() || jwt;
        const resourcePage = isCSPEnabled ? 'csp/webchat/v2/conversation/email-transcript' : 'conversational/garden-webchat-api/webchat/email-transcript';
        const response = await restClient.postFacade({ rootUri: '/' }, resourcePage, freshToken, payload);
        delete response.headers;
        delete response.request;
        delete response.config;
        // const response = await axios.post('http://localhost:8080/webchat/v2/conversation/email-transcript', payload);
        return response;
    } catch (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            errorMessage: error,
            message: `Webchat: Could not send email transcript: - payload: ${JSON.stringify(payload)} - ERROR: ${error}`,
        });
        return false;
    }
};

export default {};
